export const LOCALE = "locale";
export const FOLLOW_PROMPT_DISMISSED = "followPromptDismissed";
export const BOOKING_FILTER_EQUIPMENT = "bookingFilterEquipmentMap";
export const MORE_DATES_SHOWN = "moreDatesShown";
export const LAST_MEETING_ROOM_RE_SYNC_LOCAL_STORAGE_KEY =
  "lastMeetingRoomReSync";
export const FLOOR_PLAN_AREA_LIST_VISIBLE = "floorPlanAreaListVisible";
export const KIOSK_TOKEN = "kioskToken";
export const KIOSK_EXIT_CODE = "kioskExitCode";
